import React from 'react';
import { auth } from '../firebase';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { SignIn } from './SignIn';
import { SignUp } from './SignUp';

export const Register = ({ setUserName }) => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <SignIn />
        </Route>
        <Route path="/signup">
          <SignUp setUserName={setUserName} />
        </Route>
      </Switch>
    </Router>
  );
};

export const SignOut = () => {
  return (
    auth.currentUser && (
      <button
        className="sign-out--btn"
        onClick={() => auth.signOut().then(() => <Redirect to="/" />)}
      >
        Sign Out
      </button>
    )
  );
};
